import { isNil } from "lodash";
import { useLayoutEffect, useRef } from "react";

const PIXEL = "px";

const signatureOf = (variables) =>
  Object.entries(variables)
    .map((entry) => entry.join(":"))
    .join(";");

const useCssVariables = (ref, variables) => {
  const variablesRef = useRef(variables);
  variablesRef.current = variables;
  const signature = signatureOf(variables);

  useLayoutEffect(() => {
    const node = ref.current;
    if (isNil(node)) return;
    for (const [name, value] of Object.entries(variablesRef.current))
      node.style.setProperty(name, `${value}${PIXEL}`);
  }, [ref, signature]);
};

export default useCssVariables;
